import { render, staticRenderFns } from "./VersionForm.vue?vue&type=template&id=379838a5"
import script from "./VersionForm.vue?vue&type=script&lang=js"
export * from "./VersionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports